import { FunctionComponent } from "react";
import StackComponent from "../../../../components/stack";
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

interface EventosStackProps {
  objectWithValues: any[]
}

const EventosStack: FunctionComponent<EventosStackProps> = ({ objectWithValues }) => {
  const membrosHoje = objectWithValues?.filter((el) => {
    const fmtDat = new Date(el?.dataevento)?.toLocaleString('pt-BR')?.split(',')[0]?.replaceAll('/', '-');
    const hoje = new Date(Date.now())?.toLocaleString('pt-BR')?.split(',')[0]?.replaceAll('/', '-');
    return fmtDat?.match(hoje)
  })

  return (<>
    <StackComponent
      icon={<CalendarMonthRoundedIcon/>}
      title="Eventos"
      total={`${objectWithValues?.length}`}
      valueActual={`Novos ${membrosHoje?.length}`}
    />
  </>);
}

export default EventosStack;
